import {AbstractService} from 'services/AbstractService';
import getDefaultDetailedMetricsList from 'services/fallbackData/getDefaultDetailedMetricsList';
import translation from 'translation';
import {showNotification} from 'components/common/MNotification/MNotificationManager';
import _ from 'lodash';
import {convertSorting} from 'utils/api/requestSortingConverters';

_.noConflict();

const PROJECT_DETAILED_METRICS_LIST_URL = '/api/projects/{0}/statistics/detailed/metrics/available';
const PROJECT_STATISTICS_URL = '/api/projects/{0}/statistics';
const ACCOUNT_STATISTICS_URL = '/api/statistics';
const ACCOUNT_DETAILED_STATISTICS_URL = '/api/statistics/detailed';

const STATISTICS_DOWNLOAD_URL = '/download/statistics/{0}/{1}';

const DETAILED_STATISTICS_METRICS_AVAILABLE_LIST = '/api/statistics/detailed/metrics/available';

export class StatisticsService extends AbstractService {
  async getProjectDetailedMetricsList (accountId, projectId, profiles = []) {
    return (await this.client.get(PROJECT_DETAILED_METRICS_LIST_URL.format(projectId), {profiles}, {accountId})).items;
  }

  async getDetailedStatisticsMetricsList ({
    accountId,
    accountIds,
    profiles = []
  }) {
    return (await this.client.get(
      DETAILED_STATISTICS_METRICS_AVAILABLE_LIST, {
        account_id: accountIds,
        profiles
      }, {accountId}
    )).items;
  }

  getDefaultDetailedStatisticsMetrics () {
    return getDefaultDetailedMetricsList();
  }

  async getStatistics ({
    channelIds,
    accountId,
    projectId,
    dateStart,
    dateEnd,
    dateGrouping,
    grouping,
    filteringType,
    filterEntities,
    customMetricsList,
    profiles,
    goals,
    withVat,
    page,
    perPage,
    sorting
  }, axiosParams = {}) {
    let sort = '';
    let statUrl = projectId ? PROJECT_STATISTICS_URL : ACCOUNT_STATISTICS_URL;
    if (projectId) {
      statUrl = statUrl.format(projectId);
    }

    if (sorting) {
      sort = convertSorting(sorting);
    }

    return await this.client.get(statUrl, {
      channel_id: channelIds,
      start_date: dateStart,
      end_date: dateEnd,
      date_grouping: dateGrouping,
      grouping,
      filtering: filteringType,
      entities: filterEntities,
      custom_metrics: customMetricsList,
      profiles,
      goals,
      with_vat: withVat,
      page,
      per_page: perPage,
      sorting: sort
    }, {accountId}, axiosParams, {useBigIntParser: true});
  }

  async getDetailedStatistics ({
    channelIds,
    accountId,
    accountIds,
    projectId,
    projectIds,
    dateStart,
    dateEnd,
    dateGrouping,
    grouping,
    filteringType,
    filterEntities,
    filtering,
    profiles,
    goals,
    withVat,
    page,
    perPage,
    sorting,
    fields,
    withTotal = true
  }, axiosParams = {}) {
    let sort = '';
    let _filtering = [];
    if (filtering) {
      _filtering = filtering;
    } else if (filteringType) {
      _filtering = [
        {
          entity: filteringType,
          entities: filterEntities
        }
      ];
    }

    if (sorting) {
      sort = convertSorting(sorting);
    }

    if (projectIds && projectIds.length > 0) {
      _filtering.push({
        entity: 'project',
        entities: projectIds
      });
    } else if (projectId) {
      _filtering.push({
        entity: 'project',
        entities: [projectId]
      });
    }

    return (await this.client.post(ACCOUNT_DETAILED_STATISTICS_URL, {
      account_id: accountIds,
      channel_id: channelIds,
      start_date: dateStart,
      end_date: dateEnd,
      date_grouping: dateGrouping,
      grouping,
      filtering: _filtering,
      profiles,
      goals,
      with_vat: withVat,
      page,
      per_page: perPage,
      sorting: sort,
      columns: fields,
      with_total: withTotal
    }, {accountId}, axiosParams, {useBigIntParser: true})).data;
  }

  async DownloadStatistics ({
    accountId,
    projectId,
    type,
    format,
    filters,
    fields,
    customMetricsList,
    sorting
  }) {
    type = type || 'regular';
    customMetricsList = customMetricsList || [];

    let sortingList = sorting.map(sort => {
      const sortSign = sort.direction === 'asc' ? '' : '-';
      return `${sortSign}${sort.name}`;
    }).
      join(' ');

    try {
      const url = STATISTICS_DOWNLOAD_URL.format(type, format);
      const params = {

        // prevent empty values
        ..._.pickBy({
          account_id: accountId,
          project_id: projectId,
          channel_id: filters.channelIds,
          start_date: filters.dateStart,
          end_date: filters.dateEnd,
          date_grouping: filters.dateGrouping,
          grouping: filters.grouping,
          filtering: filters.filteringType,
          entities: filters.filterEntities,
          custom_metrics: filters.customMetricsList,
          profiles: filters.profiles,
          goals: filters.goals,
          with_vat: filters.withVat,
          page: filters.page,
          per_page: filters.perPage,
          sorting: filters.sort
        }, v => {
          if (Array.isArray(v)) {
            return v.length > 0;
          }
          return !_.isNil(_.identity(v));
        }),
        custom_metrics: customMetricsList,
        fields: fields.join(';'),
        sorting: sortingList
      };

      console.warn(params);

      const response = await this.client.get(url, params, {accountId}, {responseType: 'blob'});

      const file = new Blob([response], {type: response.type});
      const fileURL = URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = 'statistics';
      a.click();
      a.remove();
    } catch (e) {
      showNotification({
        type: 'error',
        header: translation.tr('Error'),
        text: translation.tr('Something terrible happened. Please, refresh the page'),
        closeByButton: true
      });
      throw new Error(e);
    }
  }
}
